import React, { useEffect, useState } from 'react';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Header from '../../common/components/Header/Header';
import ArrowLeftIcon from '@material-ui/icons/ArrowBack';
import styles from './backbutton.module.css';
import { navigate } from 'gatsby-link';
import GroupDefault from '../../images/icons/CompanyGrading/GroupDefault.png';
import plus from '../../images/icons/CompanyGrading/plus2.svg';
import AllBanks from '../../components/CompanyGrading/AllBanks';
import {
  getIndustryDetails,
  readPresignedUrl
} from '../../common/constants/api';
import AddBank from '../../components/CompanyGrading/AddBank';

const CompanyProfile = props => {
  let { id } = props;
  const [data, setData] = useState({});
  const [showAddBankModal, setShowAddBankModal] = useState(false);
  const [showAddBank, setAddBank] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    getIndustryDetails(id)
      .then(res => setData(res))
      .catch(() => {});
  }, []);

  useEffect(() => {
    readPresignedUrl(data?.docUrl).then(res => setImageUrl(res));
  }, [data]);

  return (
    <div className="w-full bg-navy-600">
      <div className="flex w-full">
        <Sidebar />
        <div className="w-full max-h-screen overflow-auto pt-3 pl-3 pr-4 pb-4">
          <Header />
          <div className="w-full pl-1 bg-navy-600">
            <div className="flex justify-between">
              <div>
                <button
                  className={styles.goBackButton}
                  onClick={() => navigate('/app/allcompany')}
                >
                  <ArrowLeftIcon style={{ color: 'white' }} />
                </button>
              </div>
              <div className="w-full text-right">
                <button
                  className=" w-48 h-12  mt-2 cursor-pointer text-center text-white bg-tealCol-100 rounded-md ml-auto"
                  onClick={() => {
                    setShowAddBankModal(true), setAddBank(true);
                  }}
                >
                  <div className="mx-auto inline-flex ">
                    <img className="block mr-2 -mt-px " src={plus} alt="+" />
                    <span className="text-base py-3 block">Add Bank</span>
                  </div>
                </button>
              </div>
              {showAddBank ? (
                <AddBank
                  showModal={showAddBankModal}
                  setShowModal={setShowAddBankModal}
                  setAddBank={setAddBank}
                  companyId={id}
                />
              ) : null}
            </div>
            <div className="bg-white mt-8 rounded-md pt-5 px-5">
              <div className="flex flex-row justify-between">
                <div className="flex flex-row items-center ml-1">
                  <div>
                    <img
                      className="mt-1 w-12 h-12 rounded-full"
                      src={imageUrl ? imageUrl : GroupDefault}
                    />
                  </div>
                  <div className="p-2 ml-2">
                    <p className="text-black-400 text-base">
                      {data?.companyName}
                    </p>
                  </div>
                </div>
              </div>
              <hr className="my-4" style={{ borderColor: '#dee0f0' }} />
              <div className="xmd:flex xmd:gap-20 px-1 mt-5 pb-5">
                <div className="flex mt-3">
                  <p
                    className="text-sm font-light text-black-800 font-sans"
                    style={{ width: '58px' }}
                  >
                    Type
                  </p>
                  <span className="text-black-800 mx-2">:</span>
                  <p className="text-black-400">{data?.typeOfCompany}</p>
                </div>
                <div className="flex mt-3">
                  <p
                    className="text-sm font-light text-black-800 font-sans"
                    style={{ width: '58px' }}
                  >
                    Industry
                  </p>
                  <span className="text-black-800 mx-2">:</span>
                  <p className="text-black-400">{data?.industryName}</p>
                </div>
                <div className="flex mt-3">
                  <p
                    className="text-sm font-light text-black-800 font-sans"
                    style={{ width: '58px !important' }}
                  >
                    Segment
                  </p>
                  <span className="text-black-800 mx-2">:</span>
                  <p className="text-black-400">{data?.segmentName}</p>
                </div>
              </div>
            </div>
            <AllBanks companyId={id} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyProfile;
